import axios from "axios";
import { Store } from "../Store/StoreApi";
import { Item } from "../Item/ItemApi";
import { Unit } from "../Unit/UnitApi";


export interface RecordedPrice {
    id?: string;
    price: number;
    quantity: number;
    description: string;
    entryDate: Date;
    endDate?: Date;
    store: Store;
    item: Item;
    unit: Unit;
}
export async function fetchRecordedPrices(storeId: string, itemId: string): Promise<RecordedPrice[]> {
    const response = await axios.get("/RecordedPrice/get", {
        params: {
            storeId: storeId,
            itemId: itemId
        }
    });
    return response.data;
}
export async function addRecordedPrice(newRecordedPrice: RecordedPrice): Promise<RecordedPrice> {
    const response = await axios.post("/RecordedPrice/new", newRecordedPrice);
    return response.data;
}
